import { useController, useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { InputElementProps, MonetaryInput } from '../../UI';
import { contributionFieldValuesFromForm, isContributionFieldMissing, manualPair } from '../contributionPairs';
import { useContributionDerivedFromIncomeSource } from '../hooks/useContributionDerivedFromIncomeSource';
import { InvestmentFormValues } from '../types';
import { DerivedFromIncomeSourceTooltip } from './DerivedFromIncomeSourceTooltip';

type InvestmentRecurringContributionAmountInputProps = Pick<InputElementProps, 'autoFocus'>;

export const InvestmentRecurringContributionAmountInput = ({
  autoFocus,
}: InvestmentRecurringContributionAmountInputProps) => {
  const { t: tForm } = useTranslation('form');
  const { control } = useFormContext<InvestmentFormValues>();
  const contributionDerivedFromIncomeSource = useContributionDerivedFromIncomeSource();
  const { field, fieldState } = useController<InvestmentFormValues, 'recurringContribution.amount'>({
    control,
    name: 'recurringContribution.amount',
    rules: {
      // Manual pair is "both or neither": an amount needs a frequency (and a $0/blank amount is
      // "unset", so a lone frequency blocks the save).
      validate: (_amount, formValues) =>
        !isContributionFieldMissing(manualPair, 'amount', contributionFieldValuesFromForm(formValues)),
    },
  });

  const input = (
    <MonetaryInput
      {...field}
      autoFocus={autoFocus}
      inputProps={{ readOnly: contributionDerivedFromIncomeSource }}
      status={contributionDerivedFromIncomeSource ? 'disabled' : fieldState.error ? 'errored' : 'normal'}
      label={tForm('investment-recurring-contribution-amount-input-label')}
    />
  );

  return (
    <DerivedFromIncomeSourceTooltip derived={contributionDerivedFromIncomeSource}>{input}</DerivedFromIncomeSourceTooltip>
  );
};
